/**
 * Formats a number to a shortened display format (K, M, B)
 * @param value - The number to format
 * @param decimals - Number of decimal places (default: 1)
 * @returns Formatted string like "1.2K", "3.4M", "5.6B"
 */
export function formatMetricNumber(value: number, decimals = 1): string {
  if (value === 0) return '0'

  const absValue = Math.abs(value)
  const sign = value < 0 ? '-' : ''

  if (absValue >= 1e9) {
    return sign + (absValue / 1e9).toFixed(decimals) + 'B'
  } else if (absValue >= 1e6) {
    return sign + (absValue / 1e6).toFixed(decimals) + 'M'
  } else if (absValue >= 1e3) {
    return sign + (absValue / 1e3).toFixed(decimals) + 'K'
  }

  // For values less than 1000, show as is
  return sign + absValue.toFixed(0)
}

/**
 * Formats a dollar amount to a shortened display format with $ prefix
 * @param value - The dollar amount to format
 * @param decimals - Number of decimal places (default: 1)
 * @returns Formatted string like "$1.2K", "$3.4M", "$5.6B"
 */
export function formatDollarMetric(value: number, decimals = 1): string {
  return '$' + formatMetricNumber(value, decimals)
}
